export default __webpack_public_path__ + "static/media/ghana.beaa948a.jpg";